import { useEffect, useRef, useState } from "react";
import VehicleEdit from "./vehicle-entry";
import {
  ExcelExport,
  ExcelExportColumn,
} from "@progress/kendo-react-excel-export";
import {
  Grid,
  GridCellProps,
  GridColumn,
  GridColumnMenuFilter,
  GridColumnMenuProps,
  GridDataStateChangeEvent,
  GridExpandChangeEvent,
  GridNoRecords,
} from "@progress/kendo-react-grid";

import {
  setExpandedState,
  setGroupIds,
} from "@progress/kendo-react-data-tools";
import { DataResult, process, State } from "@progress/kendo-data-query";
import { useGetVehicles } from "../../apiclient/master/useGetVehicleApi";
import { url } from "inspector";
import VehicleModel from "../../models/masters/vehicle-model";
import { SubmitStatus } from "../../core/formik-model-dialog.component";
import { API_END_POINT } from "../../constants";
import { GridCommandCell } from "../../core/grid-command-cell.component";
import { LoadingIndicator } from "../../core/loading-indicator.component";
import {
  DeleteModelDialog,
  DeletePostDataInfo,
  DeleteStatus,
} from "../../core/delete-model-dialog.component";
import VehicleEntry from "./vehicle-entry";
import { GridActionComponent } from "../../core/action.title.component";

export const addOrUpdateArrayItem = (data: any[], item: any, key: string) => {
  const newData = data ? [...data] : [];
  const index = data?.findIndex((d) => d[key] === item[key]);
  console.log("the index is" + index);
  if (index > -1) {
    newData.splice(index, 1, item);
  } else {
    newData.push(item);
  }
  return newData;
};

const VehiclePage: React.FC = () => {
  const initialDataState: State = {
    take: 10,
    skip: 0,
    group: [],
  };
  const [dataState, setDataState] = useState<State>(initialDataState);
  const [deleteVehicleData, setDeleteVehicleData] =
    useState<DeletePostDataInfo>();
  const [collapsedState, setCollapsedState] = useState<string[]>([]);
  const [resultData, setResultData] = useState<DataResult>();

  const [editModal, setEditModal] = useState<boolean>(false);
  const [editData, setEditdata] = useState<VehicleModel>(null);
  const exportExcel = useRef<ExcelExport | null>(null);
  const [viewModal, setViewModal] = useState<boolean>(false);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const [pgreset, setpgreset] = useState<boolean>(false);

  const {
    data: result,
    isLoading,
    isError,
    refetch: reloadVehicle,
  } = useGetVehicles();

  const processWithGroups = (data: VehicleModel[], dataState: State) => {
    const groups = dataState.group;
    dataState.group = groups;
    const newDataState = process(data, dataState);
    setGroupIds({ data: newDataState.data, group: dataState.group });
    return newDataState;
  };

  const fetchData = async () => {
    try {
      setIsRefreshing(true);
      const { data, error } = await reloadVehicle();
      if (error) {
        console.error("Error reloading:", error);
      } else {
        console.log("Reloaded data:", data);
      }
    } catch (err) {
      console.error("Unexpected error:", err);
    } finally {
      setIsRefreshing(false);
    }
  };
  useEffect(() => {
    setEditdata(null);
    fetchData();
    if (result) {
      setResultData(processWithGroups(result, initialDataState));
    }
  }, [result]);

  let newData: any = null;
  if (resultData) {
    newData = setExpandedState({
      data: resultData.data,
      collapsedIds: collapsedState,
    });
  }

  const onSaveComplete = (status: SubmitStatus, data: VehicleModel) => {
    if (status === SubmitStatus.Completed) {
      reloadVehicle();
      setResultData(processWithGroups(newData, dataState));
    }
    setEditdata(null);
  };

  const excelExport = () => {
    if (exportExcel.current !== null) {
      exportExcel.current.save();
    }
  };

  const onAddNew = () => {
    setEditModal(true);
    setEditdata(new VehicleModel());
  };

  const onEdit = (data: VehicleModel) => {
    setEditModal(true);
    setViewModal(false);
    setEditdata(data);
  };
  const onView = (data: VehicleModel) => {
    setViewModal(true);
    setEditdata(data);
  };

  const onRemove = (data: VehicleModel) => {
    const { vehicleId } = data;
    console.log(data);
    setDeleteVehicleData({
      data,
      route: `Vehicle/DeleteVehicle/${vehicleId}`,
      endpoint: API_END_POINT.MASTER,
    });
    reloadVehicle();
  };

  const onDeleteComplete = (status: DeleteStatus, data: VehicleModel) => {
    if (status === DeleteStatus.Completed) {
      reloadVehicle();
      setResultData(processWithGroups(result, dataState));
    }
    setDeleteVehicleData(null);
  };
  const ColumnMenu = (props: GridColumnMenuProps) => {
    return (
      <div>
        <GridColumnMenuFilter {...props} expanded={true} />
      </div>
    );
  };

  const CommandCell = (props: GridCellProps) => (
    <GridCommandCell
      {...props}
      edit={onEdit}
      remove={onRemove}
      add={onAddNew}
      view={onView}
      dataItem={props.dataItem}
      idPropertyName="vehicleId"
      editPermissionName={null}
      deletePermissionName={null}
    />
  );

  const onSearch = (e: any) => {
    if (e.target.value.length > 0) {
      const searchKey: string = e.target.value;
      const filteredData = result?.filter(
        (p) => p?.code?.toLowerCase().includes(searchKey?.toLowerCase())
        // p?.name?.toLowerCase().includes(searchKey?.toLowerCase()) ||
        //p?.description?.toLowerCase().includes(searchKey?.toLowerCase())
      );
      setResultData(process(filteredData, dataState));
    } else {
      setResultData(process(result, dataState));
    }
  };

  const expandChange = (event: GridExpandChangeEvent) => {
    const item = event.dataItem;

    if (item.groupId) {
      const newCollapsedIds = !event.value
        ? [...collapsedState, item.groupId]
        : collapsedState.filter((groupId) => groupId !== item.groupId);
      setCollapsedState(newCollapsedIds);
    }
  };

  const ColumnFormatBoolean = (props: any) => {
    return (
      <td
        {...props.tdProps}
        colSpan={1}
        style={{
          color: "black",
        }}
      >
        {props.children === "true" ? (
          <span style={{ color: "green", fontWeight: "bold" }}>Yes</span>
        ) : (
          <span style={{ color: "red", fontWeight: "bold" }}>No</span>
        )}
      </td>
    );
  };
  const refreshGrid = () => {
    reloadVehicle();
  };
  const dataStateChange = (event: GridDataStateChangeEvent) => {
    const newDataState = processWithGroups(result, event.dataState);
    setResultData(newDataState);
    setDataState(event.dataState);
  };

  const onAddClick = () => {
    setEditModal(true);
    setViewModal(false);
    setEditdata(new VehicleModel());
  };
  let grid = null;
  if (result) {
    grid = (
      <Grid
        data={newData}
        pageable={{ pageSizes: [10, 20, 50, 100] }}
        total={resultData?.total}
        groupable={true}
        sortable={true}
        onDataStateChange={dataStateChange}
        {...dataState}
        onExpandChange={expandChange}
        columnVirtualization={false}
        resizable={true}
      >
        {/* <GridToolbar className="export-bg">
       
        </GridToolbar> */}
        <GridColumn
          field="code"
          title="Code"
          columnMenu={ColumnMenu}
        />
        <GridColumn
          field="driverName"
          title="Driver Name"
        />
        <GridColumn
          field="vehicleNumber"
          title="Vehicle Number"
        />
        {/* <GridColumn
          field="driverMobile"
          title="Driver Mobile "
        /> */}
        <GridColumn
          field="licenceNumber"
          title="Licence Number"
        />
        <GridColumn
          field="capacityInKg"
          title="Capacity In Kg"
        />

        <GridColumn
          field="isActive"
          title="Active ?"
          cells={{ data: ColumnFormatBoolean }}
        />
        <GridColumn
          cell={CommandCell}
          title="Action"
          groupable={true}
        />
        <GridNoRecords>
          <div className="mt-2" style={{ width: "100%", height: "500px" }}>
            <center>
              <h5>No data found</h5>
            </center>
          </div>
        </GridNoRecords>
      </Grid>
    );
    if (isError) {
      return (
        <div>
          <h4>Error Loadong Page..</h4>
        </div>
      );
    }
    return (
      <>
        <div
          style={{ minHeight: "600px" }}
          className="card p-3 border-0 m-3 sw-shadow radius-15"
        >
          <div>
            <GridActionComponent
              onSearchClick={onSearch}
              addButtonClick={onAddClick}
              excelExportClick={excelExport}
              refreshClick={fetchData}
              title="VEHICLE"
              addButtonTooltip="Add Vehicle"

            ></GridActionComponent>

          </div>
          {editModal && (
            <VehicleEntry data={editData} isViewMode={viewModal} onClose={onSaveComplete} />
          )}
          {viewModal && (
            <VehicleEntry
              isViewMode={true}
              data={editData}
              onClose={onSaveComplete}
            />
          )}
          {deleteVehicleData && (
            <DeleteModelDialog
              title="Delete Vehicle"
              deleteData={deleteVehicleData}
              onClose={onDeleteComplete}
            >
              <div>
                Are you sure you want to delete Vehicle :{" "}
                <span style={{ fontWeight: "bold" }}>
                  {deleteVehicleData.data.code}
                </span>
                ?
              </div>
            </DeleteModelDialog>
          )}

          <div>
            <>
              {isRefreshing || isLoading ? (
                <LoadingIndicator isLoading={isRefreshing}></LoadingIndicator>
              ) : (
                <div>
                  {grid}
                  <ExcelExport
                    fileName={"Vehicle_List"}
                    data={result}
                    ref={exportExcel}
                  >
                    <ExcelExportColumn width={100} field="code" title="Code" />
                    <ExcelExportColumn
                      width={100}
                      field="vehicleNumber"
                      title="Vehicle Number"
                    />
                    <ExcelExportColumn
                      width={100}
                      field="driverName"
                      title="Driver Name"
                    />
                    <ExcelExportColumn
                      width={100}
                      field="licenceNumber"
                      title="Licence Number"
                    />
                    <ExcelExportColumn
                      width={100}
                      field="driverMobile"
                      title="Driver Mobile"
                    />

                    <ExcelExportColumn
                      width={100}
                      field="capacityInKg"
                      title="Capacity InKg"
                    />
                    <ExcelExportColumn
                      width={100}
                      field="vehicleTransportName"
                      title="Vehicle Transport Name"
                    />
                    <ExcelExportColumn
                      width={100}
                      field="vehicleTypeName"
                      title="Vehicle Type Name"
                    />
                    <ExcelExportColumn
                      width={100}
                      field="fcExpiryDate"
                      title="Fc Expiry Date"
                    />
                    <ExcelExportColumn
                      width={100}
                      field="insuranceExpiryDate"
                      title="Insurance Expiry Date"
                    />
                    <ExcelExportColumn
                      width={100}
                      field="contractStartFrom"
                      title="Contract Start From"
                    />
                    <ExcelExportColumn
                      width={100}
                      field="contractEndsOn"
                      title="Contract Ends On"
                    />
                    <ExcelExportColumn
                      width={100}
                      field="trayCapacity"
                      title="Tray Capacity"
                    />
                    <ExcelExportColumn
                      width={100}
                      field="isActive"
                      title="Is Active"
                    />
                  </ExcelExport>
                </div>
              )}
            </>
          </div>
          <div></div>
        </div>
      </>
    );
  }
};
export default VehiclePage;
